<template>
  <div class="row mb-4">
    <div class="card rounded-3 shadow-sm rounded">
      <div class="card-header bg-white border-bottom-0 text-secondary py-1">
        <h4 class="mb-0">{{ tableContentAnalyzerTitle }}</h4>
      </div>
      <div class="card-body pt-1">
        <div class="table-responsive table-xs pb-0 pr-2" :style="{'max-height': tablesHeight, 'max-width': '90vw'}">

          <table class="table border border-600 mb-0 shadow-sm headerAlwaysVisible" :style="{'max-height': '90vh', 'max-width': '90vw'}">

            <thead class="cf ">
              <tr >
                <th class="border border-300" scope="col" v-for="(compareSelector,i) in compareSelectors" :key="i" data-toggle="modal" data-target="#updateSelectorModal" v-on:click="saveSelectedSelectorsIndex(i)">


                  <div class="rounded mb-1 bg-transparent" v-for="(inputTableSelector,index) in compareSelector.inputTableSelectors" :key="'inputTableSelector-'+index">
                    <span v-if="inputTableSelector.columnId !== undefined" class="smaller-font-size" > Column: {{ inputTableSelector.columnId }}</span>
                    <span v-if="inputTableSelector.rowId !== undefined" class="smaller-font-size" > Row: {{ inputTableSelector.rowId }}</span>
                  </div>

                  <div>
                    <span class="icon icon-mobile-data-toggle mt-1 mb-1 mr-0 ml-0 compare-icon-sm" aria-hidden="true" :title="'compared with'"></span>
                  </div>

                  <div class="rounded mb-1 bg-transparent" v-for="(revisedTableSelector,index) in compareSelector.revisedTableSelectors" :key="'revisedTableSelector-'+index">
                    <span v-if="revisedTableSelector.columnId !== undefined" class="smaller-font-size" > Column: {{ revisedTableSelector.columnId }}</span>
                    <span v-if="revisedTableSelector.rowId !== undefined" class="smaller-font-size" > Row: {{ revisedTableSelector.rowId }}</span>
                  </div>

                </th>

              </tr>
            </thead>


            <tr v-for="(line,i) in compareArray" :key="i">
              <td class="border border-300" v-for="(element,index) in line" :key="index">

                <EntryContentDiff :displayDiff2Html="true" :inputTableSelectorsValues="element.inputTableSelectorsValues" :revisedTableSelectorsValues="element.revisedTableSelectorsValues" :concatSeparator="'\n'">
                </EntryContentDiff>

              </td>
            </tr>
          </table>

          <div class="modal fade" id="updateSelectorModal" tabIndex="-1" role="dialog" aria-labelledby="updateSelectorModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="updateSelectorModalTitle">Update Data Tables comparison selectors</h5>
                  <button type="button" id="closeUpdateSelectorsModalButton" class="close" data-dismiss="modal" aria-label="Close">
                  </button>
                </div>
                <div class="modal-body text-left">

                  <div class="form-row mt-2">
                    <div class="form-group col align-items-left mb-0">

                      <label>Selectors for Input Table Data</label>

                      <div class="input-group">
                        <div class="form-check form-check-inline ml-3 mt-2">
                          <input class="form-check-input" type="radio" name="inputTableSelectorsMethod" id="inputTableSelectorsMethodByColumnId" value="byColumnId" v-model="inputTableSelectorsMethod" v-on:change="onChangeInputTableSelectorsMethod($event)" :disabled="orientation !== 'HORIZONTAL'">
                          <label class="form-check-label">By columnId</label>
                        </div>
                        <div class="form-check form-check-inline ml-3 mt-2">
                          <input class="form-check-input" type="radio" name="inputTableSelectorsMethod" id="inputTableSelectorsMethodByColumnHeaderName" value="byColumnHeaderName" v-model="inputTableSelectorsMethod" v-on:click="onChangeInputTableSelectorsMethod($event)" disabled>
                          <label class="form-check-label">By columnName</label>
                        </div>
                        <div class="form-check form-check-inline ml-3 mt-2">
                          <input class="form-check-input" type="radio" name="inputTableSelectorsMethod" id="inputTableSelectorsMethodByRowId" value="byRowId" v-model="inputTableSelectorsMethod" v-on:change="onChangeInputTableSelectorsMethod($event)" :disabled="orientation === 'HORIZONTAL'">
                          <label class="form-check-label">By rowId</label>
                        </div>
                        <div class="form-check form-check-inline ml-3 mt-2">
                          <input class="form-check-input" type="radio" name="inputTableSelectorsMethod" id="inputTableSelectorsMethodByRowHeaderName" value="byRowHeaderName" v-model="inputTableSelectorsMethod" v-on:click="onChangeInputTableSelectorsMethod($event)" disabled>
                          <label class="form-check-label">By rowName</label>
                        </div>
                      </div>

                      <div v-if="orientation === 'HORIZONTAL'" class="form-group mb-0">
                        <label class="d-none" for="inputTableSelectorsColumnIdSelect" sr-only="Select columns ids list for Input Table Data">Input Table Data columns ids:</label>
                        <select class="form-control" id="inputTableSelectorsColumnIdSelect" multiple v-model="inputTableSelectorsColumnIdsSelected" :class="{ 'd-none': inputTableSelectorsMethod !== 'byColumnId'}">
                          
                          <option v-for="inputTableColumnId in inputTableColumnIds" :key="inputTableColumnId">{{ inputTableColumnId }}</option>

                        </select>
                      </div>

                      <div v-if="orientation !== 'HORIZONTAL'" class="form-group mb-0">
                        <label class="d-none" for="inputTableSelectorsRowIdSelect" sr-only="Select rows ids list for Input Table Data">Input Table Data rows ids:</label>
                        <select class="form-control" id="inputTableSelectorsRowIdSelect" multiple v-model="inputTableSelectorsRowIdsSelected" :class="{ 'd-none': inputTableSelectorsMethod !== 'byRowId'}">
                          
                          <option v-for="inputTableRowId in inputTableRowIds" :key="inputTableRowId">{{ inputTableRowId }}</option>

                        </select>
                      </div>

                    </div>
                  </div>
                
                  <hr>

                  <div class="form-row">
                    <div class="form-group col align-items-left">

                      <label>Selectors for Revised Table Data</label>

                      <div class="input-group">
                        <div class="form-check form-check-inline ml-3 mt-2">
                          <input class="form-check-input" type="radio" name="revisedTableSelectorsMethod" id="revisedTableSelectorsMethodByColumnId" value="byColumnId" v-model="revisedTableSelectorsMethod" v-on:change="onChangeRevisedTableSelectorsMethod($event)" :disabled="revisedTableOrientation !== 'HORIZONTAL'">
                          <label class="form-check-label">By columnId</label>
                        </div>
                        <div class="form-check form-check-inline ml-3 mt-2">
                          <input class="form-check-input" type="radio" name="revisedTableSelectorsMethod" id="revisedTableSelectorsMethodByColumnHeaderName" value="byColumnHeaderName" v-model="revisedTableSelectorsMethod" v-on:click="onChangeRevisedTableSelectorsMethod($event)" disabled>
                          <label class="form-check-label">By columnName</label>
                        </div>
                        <div class="form-check form-check-inline ml-3 mt-2">
                          <input class="form-check-input" type="radio" name="revisedTableSelectorsMethod" id="revisedTableSelectorsMethodByRowId" value="byRowId" v-model="revisedTableSelectorsMethod" v-on:change="onChangeRevisedTableSelectorsMethod($event)" :disabled="revisedTableOrientation === 'HORIZONTAL'">
                          <label class="form-check-label">By rowId</label>
                        </div>
                        <div class="form-check form-check-inline ml-3 mt-2">
                          <input class="form-check-input" type="radio" name="revisedTableSelectorsMethod" id="revisedTableSelectorsMethodByRowHeaderName" value="byRowHeaderName" v-model="revisedTableSelectorsMethod" v-on:click="onChangeRevisedTableSelectorsMethod($event)" disabled>
                          <label class="form-check-label">By rowName</label>
                        </div>
                      </div>

                      <div v-if="revisedTableOrientation === 'HORIZONTAL'" class="form-group mb-1">
                        <label class="d-none" for="revisedTableSelectorsColumnIdSelect" sr-only="Select columns ids list for Revised Table Data">Revised Table Data columns ids:</label>
                        <select class="form-control" id="revisedTableSelectorsColumnIdSelect" multiple v-model="revisedTableSelectorsColumnIdsSelected" :class="{ 'd-none': revisedTableSelectorsMethod !== 'byColumnId'}">
                          
                          <option v-for="revisedTableColumnId in revisedTableColumnIds" :key="revisedTableColumnId">{{ revisedTableColumnId }}</option>

                        </select>
                      </div>

                      <div v-if="revisedTableOrientation !== 'HORIZONTAL'" class="form-group mb-1">
                        <label class="d-none" for="revisedTableSelectorsRowIdSelect" sr-only="Select rows ids list for Revised Table Data">Revised Table Data rows ids:</label>
                        <select class="form-control" id="revisedTableSelectorsRowIdSelect" multiple v-model="revisedTableSelectorsRowIdsSelected" :class="{ 'd-none': revisedTableSelectorsMethod !== 'byRowId'}">
                          
                          <option v-for="revisedTableRowId in revisedTableRowIds" :key="revisedTableRowId">{{ revisedTableRowId }}</option>

                        </select>
                      </div>

                    </div>
                  </div>

                </div>

                
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="onAbortSelectorsUpdate">Abort</button>
                  <button type="button" class="btn btn-primary" v-on:click="onSelectorsUpdate">Update this selectors</button>
                </div>

    
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>
<script>
import EntryContentDiff from "./EntryContentDiff";

export default {
  name: "TableContentAnalyzer",
  components: {
    EntryContentDiff
  },
  props: ["tableContentAnalyzerTitle", "originalTableMatrixToCompare", "resultTableMatrixToCompare", "compareOptions", "orientation", "hasHeader", "headerPosition", "repeatHeaderInArrayContent", "maxHeight"],
  data() {
    return {
      compareSelectors: undefined,
      selectedSelectorsIndex: undefined,
      inputTableSelectorsMethod: (this.orientation === 'HORIZONTAL') ? 'byColumnId' : 'byRowId',
      inputTableSelectorsColumnIdsSelected: [],
      inputTableSelectorsRowIdsSelected: [],
      revisedTableSelectorsMethod: 'byColumnId',
      revisedTableSelectorsColumnIdsSelected: [],
      displayHeaderLineAsFirstLine: true,
      defaultComparisonMaxHeight: 'auto'
    }
  },
  mounted() {
    this.compareSelectors = this.getDefaultCompareSelectors();
  },
  computed: {
    selectedInputTableSelectors: function() {
      return this.compareSelectors[this.selectedSelectorsIndex].inputTableSelectors;
    },
    selectedRevisedTableSelectors: function() {
      return this.compareSelectors[this.selectedSelectorsIndex].revisedTableSelectors;
    },
    revisedTableOrientation: function() {
      return 'HORIZONTAL';
    },
    revisedTableColumnIds: function() {
      if ((this.resultTableMatrixToCompare !== undefined) && (this.resultTableMatrixToCompare.getRow(0) !== undefined)) {
        return this.getTableIds(this.resultTableMatrixToCompare.getRow(0));
      } else {
        return [];
      }
    },
    inputTableColumnIds: function() {
      if ((this.originalTableMatrixToCompare !== undefined) && (this.originalTableMatrixToCompare.getRow(0) !== undefined)) {
        return this.getTableIds(this.originalTableMatrixToCompare.getRow(0));
      } else {
        return [];
      }
    },
    revisedTableRowIds: function() {
      if ((this.resultTableMatrixToCompare !== undefined) && (this.resultTableMatrixToCompare.getColumn(0) !== undefined)) {
        return this.getTableIds(this.resultTableMatrixToCompare.getColumn(0));
      } else {
        return [];
      }
    },
    inputTableRowIds: function() {
      if ((this.originalTableMatrixToCompare !== undefined) && (this.originalTableMatrixToCompare.getColumn(0) !== undefined)) {
        return this.getTableIds(this.originalTableMatrixToCompare.getColumn(0));
      } else {
        return [];
      }
    },
    tablesHeight: function() {
      return this.defaultComparisonMaxHeight;
    },
    compareArray: function() {
      let returnedCompareArray = [];

      if ((this.compareSelectors !== undefined) && (this.originalTableMatrixToCompare !== undefined) && (this.resultTableMatrixToCompare !== undefined)) {
      
        const originalTableMatrixMaxLoopIndex = this.orientation === 'HORIZONTAL' ? this.originalTableMatrixToCompare.getMaxRowsLength() : this.originalTableMatrixToCompare.getMaxColumnsLength();
        const resultTableMatrixMaxLoopIndex = this.revisedTableOrientation === 'HORIZONTAL' ? this.resultTableMatrixToCompare.getMaxRowsLength() : this.resultTableMatrixToCompare.getMaxColumnsLength();
        const loopMaxIndex = resultTableMatrixMaxLoopIndex > originalTableMatrixMaxLoopIndex ? resultTableMatrixMaxLoopIndex : originalTableMatrixMaxLoopIndex;

        for(let i=0; i<loopMaxIndex; i++) {
          let originalTableSelectorsValues;
          let resultTableSelectorsValues;

          if (this.orientation === 'HORIZONTAL') {
            // Define originalTableLoopEntry from row
            const originalTableLoopEntry = this.originalTableMatrixToCompare.getRow(i);
            const isRowTableEntry = true;
            originalTableSelectorsValues = this.getTableEntrySelectorsValues(originalTableLoopEntry, isRowTableEntry, this.compareSelectors.map(compareSelector => compareSelector.inputTableSelectors));
          } else {
            // Define originalTableLoopEntry from column
            const originalTableLoopEntry = this.originalTableMatrixToCompare.getColumn(i);
            const isRowTableEntry = false;
            originalTableSelectorsValues = this.getTableEntrySelectorsValues(originalTableLoopEntry, isRowTableEntry, this.compareSelectors.map(compareSelector => compareSelector.inputTableSelectors));
          }

          if (this.revisedTableOrientation === 'HORIZONTAL') {
            // Define originalTableLoopEntry from row
            const resultTableLoopEntry = this.resultTableMatrixToCompare.getRow(i);
            const isRowTableEntry = true;
            resultTableSelectorsValues = this.getTableEntrySelectorsValues(resultTableLoopEntry, isRowTableEntry, this.compareSelectors.map(compareSelector => compareSelector.revisedTableSelectors));
          } else {
            // Define originalTableLoopEntry from column
            const resultTableLoopEntry = this.resultTableMatrixToCompare.getColumn(i);
            const isRowTableEntry = false;
            resultTableSelectorsValues = this.getTableEntrySelectorsValues(resultTableLoopEntry, isRowTableEntry, this.compareSelectors.map(compareSelector => compareSelector.revisedTableSelectors));
          }

          const entryValuesArray = [];
          for (let i=0 ; i<originalTableSelectorsValues.length ; i++) {
            entryValuesArray.push({ inputTableSelectorsValues: originalTableSelectorsValues[i], revisedTableSelectorsValues: resultTableSelectorsValues[i]});
          }
          returnedCompareArray.push(entryValuesArray);
        }
      }
      return returnedCompareArray;
    } 
  },
  methods: {
    onAbortSelectorsUpdate: function() {
    },
    onSelectorsUpdate: function() {
      if (this.inputTableSelectorsMethod === 'byColumnId') {
        this.compareSelectors[this.selectedSelectorsIndex].inputTableSelectors = this.inputTableSelectorsColumnIdsSelected.map(i => {
          return { 'columnId': i }
        })
      }
      if (this.revisedTableSelectorsMethod === 'byColumnId') {
        this.compareSelectors[this.selectedSelectorsIndex].revisedTableSelectors = this.revisedTableSelectorsColumnIdsSelected.map(i => {
          return { 'columnId': i }
        })
      }
      if (this.inputTableSelectorsMethod === 'byRowId') {
        this.compareSelectors[this.selectedSelectorsIndex].inputTableSelectors = this.inputTableSelectorsRowIdsSelected.map(i => {
          return { 'rowId': i }
        })
      }
      if (this.revisedTableSelectorsMethod === 'byRowId') {
        this.compareSelectors[this.selectedSelectorsIndex].revisedTableSelectors = this.revisedTableSelectorsRowIdsSelected.map(i => {
          return { 'rowId': i }
        })
      }
      document.getElementById('closeUpdateSelectorsModalButton').click();
    },
    onChangeRevisedTableSelectorsMethod: function(event) {
      this.revisedTableSelectorsMethod = event.target.value;
    },
    onChangeInputTableSelectorsMethod: function(event) {
      this.inputTableSelectorsMethod = event.target.value;
    },
    saveSelectedSelectorsIndex: function(value) {
      this.selectedSelectorsIndex = value;

      this.inputTableSelectorsColumnIdsSelected = this.selectedInputTableSelectors.filter(i => i.columnId !== undefined).map(i => i.columnId);
      this.revisedTableSelectorsColumnIdsSelected = this.selectedRevisedTableSelectors.filter(i => i.columnId !== undefined).map(i => i.columnId);

      this.inputTableSelectorsRowIdsSelected = this.selectedInputTableSelectors.filter(i => i.rowId !== undefined).map(i => i.rowId);
      this.revisedTableSelectorsRowIdsSelected = this.selectedRevisedTableSelectors.filter(i => i.rowId !== undefined).map(i => i.rowId);
    },
    getTableIds: function(table) {
      const returnedTableIds = [];
      for (let i=0 ; i<table.length ; i++) {
        returnedTableIds.push(i);
      }
      return returnedTableIds;
    },
    getTableEntrySelectorsValues: function(tableEntry, isRowTableEntry, arrayOfSelectors) {
      if ((arrayOfSelectors === undefined) || !Array.isArray(arrayOfSelectors) || (arrayOfSelectors.length < 1)) {
        return [];
      } else {
        const returnedResponse = arrayOfSelectors.map((selectors) => {
          if ((selectors === undefined) || !Array.isArray(selectors) || (selectors.length < 1)) {
            return [];
          } else {
            return selectors.map((selector) => this.getTableEntrySelectorValue(tableEntry, isRowTableEntry, selector))
          }
        });
        return returnedResponse;
      }
    },
    getTableEntrySelectorValue: function(tableEntry, isRowTableEntry, selector) {
      let returnedSelectorValue = "<undefined>";
      if (tableEntry !== undefined) {
        if (isRowTableEntry) {
          if (selector.columnId !== undefined) {
            returnedSelectorValue = tableEntry[selector.columnId];
          }
        } else {
          if (selector.rowId !== undefined) {
            returnedSelectorValue = tableEntry[selector.rowId];
          }
        }
      }
      return returnedSelectorValue;
    },
    isHeaderLine: function(index) {
      let result = false;
      if ((this.orientation === 'HORIZONTAL') && (this.hasHeader === true) && (this.headerPosition === index)) {
      // if ((this.orientation === 'HORIZONTAL') && (this.hasHeader === true) && (10 === index)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    getDefaultCompareSelectors: function() {
      const defaultOption = (this.orientation === 'HORIZONTAL') ? { compareByColumnId: true } : { compareLineIdWithColumnId: true };
      const options = (this.compareOptions !== undefined) ? this.compareOptions : defaultOption;
      const defaultSelectors = [];
      if (options.compareByColumnId === true) {
        if (this.originalTableMatrixToCompare !== undefined) {
          for (let i in this.getTableIds(this.originalTableMatrixToCompare.getRow(0))) {
            if (i === "2") {
              defaultSelectors.push({ inputTableSelectors: [{columnId: "2"}], revisedTableSelectors: [{columnId: "2"}] });
              // defaultSelectors.push({ inputTableSelectors: [{columnId: "2"}], revisedTableSelectors: [{columnId: "3"}] });
              // defaultSelectors.push([[{columnId: "2"}], [{columnId: "2"}]])
            } else if (i === "3") {
              defaultSelectors.push({ inputTableSelectors: [{columnId: "3"}], revisedTableSelectors: [{columnId: "3"}] });
              // defaultSelectors.push({ inputTableSelectors: [{columnId: "3"}], revisedTableSelectors: [{columnId: "2"}] });
              // defaultSelectors.push([[{columnId: "3"}], [{columnId: "2"}]])
              // defaultSelectors.push([[{columnId: "3"}], [{columnId: "3"}]])
            } else if (i === "8") {
              defaultSelectors.push({ inputTableSelectors: [{columnId: "8"}], revisedTableSelectors: [{columnId: "8"}] });
              // defaultSelectors.push({ inputTableSelectors: [{columnId: "8"}, {columnId: "9"}], revisedTableSelectors: [{columnId: "8"}] });
              // defaultSelectors.push([[{columnId: "8"}, {columnId: "9"}], [{columnId: "8"}]])
              // defaultSelectors.push([[{columnId: "8"}], [{columnId: "8"}]])
            } else {
              defaultSelectors.push({ inputTableSelectors: [{columnId: i}], revisedTableSelectors: [{columnId: i}] });
              // defaultSelectors.push([[{columnId: i}], [{columnId: i}]])
            }
          }
        }
      } else if (options.compareLineIdWithColumnId === true) {
        if (this.originalTableMatrixToCompare !== undefined) {
          for (let i in this.getTableIds(this.originalTableMatrixToCompare.getRows())) {
            defaultSelectors.push({ inputTableSelectors: [{rowId: i}], revisedTableSelectors: [{columnId: i}] });
          }
        }
      } else {
        // Define another compare selector
      }
      return defaultSelectors;
    }

  }

};
</script>
<style scoped>

.compare-icon-sm {
  font-size: 1rem;
  height: 1rem;
}

table.headerAlwaysVisible th {
  position: sticky;
  top: 0px;
  background-color: whitesmoke;
}

.table-xs td, .table-xs th {
  padding: .2625rem .2625rem calc(.2625rem + 1px);
}

.custom-small-border-top {
  border-top-width: 0.156rem !important;
}

.smaller-font-size {
  font-size: smaller;
}

</style>